import PropTypes from 'prop-types';
import React from "react";

import {
  ToolBar,
  ToolBarGroup,
} from "src/legacy/components/ToolBar/ToolBar";
import dateformat from "dateformat";
import Transition from "react-transition-group/Transition";
import Tooltip from "src/components/tooltip";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";

// import SlidePaneView from "src/components/SlidePaneView";
import cx from "classnames";
import styles from "./ContactListDetailsView.module.scss";
import commonStyles from "../Styles.module.scss";

import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import RolodexActivityEmptyMessage from "src/legacy/images/rolodexActivityEmptyMessage.svg";
import ContactListEmptyMessageSvgIcon from "src/legacy/images/contactListEmptyMessage.svg";

import ContactListItemRow from "./../components/ContactListItemRow";
import Button from "src/components/button";
import DeleteContactListContainer from "./../DeleteContactListContainer";
import userRoleService from "src/services/userRoles.service.js";
import { localizedStrings } from 'src/localization';
import Slider from 'src/components/slider';
import Actions from 'src/components/actionbar';
import Text from 'src/components/text';
class ContactListDetailsView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      currentPage: this.props.currentPage,
      showShareView: false,
      editing: false,
      name: "",
      errors: {},
      showDeleteConfirmation: false,
    };

    this._handleChange = this._handleChange.bind(this);
    this._handleUpdateClicked = this._handleUpdateClicked.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleDeleteClicked = this._handleDeleteClicked.bind(this);
    this._handleAddContacts = this._handleAddContacts.bind(this);
    this._handleRemoveContact = this._handleRemoveContact.bind(this);
    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleCreateClick = this._handleCreateClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedDistributionList = this.localizatedSettings.distribution_lists;
    this.localizedAddContacts = this.localizedDistributionList.sliders.add_contacts;
  }

  componentDidMount() {
    if (
      this.props.contactLists &&
      this.props.contactLists.length > 0 &&
      this.props.id
    ) {
      this.props.viewContactList("props", this.props.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id != nextProps.id) {
      this.props.viewContactList(nextProps.id);
    }

    var current = this.props.contactList;
    var next = nextProps.contactList;

    var changed = true;
    if (current && next) {
      changed = current.id != next.id;
    }

    if (changed && next) {
      this.props.fetchContactList(next.id);
    }

    if (
      !_.isEqual(this.props.contactLists, nextProps.contactLists) &&
      !current
    ) {
      this.props.fetchContactList(nextProps.id);
    }
  }

  _handleCreateClick() {
    this.props.onCreateDistributionClick();
  }

  _handleAddContacts() {
    this.props.onAddContactsClick();
  }

  _handleUpdateClicked() {
    this.setState({
      editing: true,
      name: this.props.contactList.name,
    });
  }

  _handleSaveClick() {
    const errors = this.validateForm();
    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors,
      });

      return;
    }

    var contacts = this.props.contactList.contacts.map((item) => {
      return item.id;
    });

    var request = {
      name: this.state.name,
      contacts: contacts,
    };

    this.props
      .updateContactList(this.props.contactList.id, request)
      .then(() => {
        this._handleCancelClick();
      });
  }

  _handleCancelClick() {
    this.setState({
      editing: false,
    });
    this.props.fetchContactList(this.props.id);
  }

  _handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
    });
  }

  _handleDeleteClicked() {
    this.setState({
      showDeleteConfirmation: true,
    });
  }

  _handleRemoveContact(contact) {
    if (!this.state.editing) {
      return;
    }

    this.props.removeContactFromContactList(this.props.contactList.id, contact);
  }

  validateForm() {
    let errors = {};
    const { name } = this.state;
    if (!name || name.trim() == "") {
      errors.name = this.localizedDistributionList.sliders.add_contacts.empty_message.name;
    }

    return errors;
  }

  _renderDistributionListEmptyMessage() {
    return (
      userRoleService.canCreateContact() && (
        <PlaceholderEmptyMessage
          title={this.localizedDistributionList.empty_message.distribution_list.title}
          message={this.localizedDistributionList.empty_message.distribution_list.message}
          image={ContactListEmptyMessageSvgIcon}
          className={styles.emptyMessage}
          buttonText={this.localizedDistributionList.empty_message.distribution_list.actions.create_now}
          onClick={this._handleCreateClick}
          visible={true}
        />
      )
    );
  }

  render() {
    if (
      !this.props.contactLists ||
      this.props.contactLists.length == 0 ||
      !this.props.contactList
    ) {
      return this._renderDistributionListEmptyMessage();
    }


    return (
      <div className={styles.list}>
        <div
          className={styles.inner}
          ref={(element) => {
            this.scrollContainer = element;
          }}
        >
         

          <Row className={styles.contactDetails}>
            <Col md={7}>
            <div>
                <div className={styles.body}>
                  {!this.state.editing && (
                    <div className={styles.contactName}>
                      <Text text={_.get(this.props, 'contactList.name', '')} lines={1} tooltip={{placement: "auto"}} />
                    </div>
                  )}

                  {this.state.editing && (
                    <div className={styles.contactNameEdit}>
                      <input
                        className={styles.nameInput}
                        type="text"
                        placeholder={this.localizedAddContacts.placeholder.name}
                        onChange={this._handleChange.bind(this, "name")}
                        value={this.state.name}
                        spellCheck={true}
                      />

                      {this.state.errors.name && (
                        <span className={styles.errorMessage}>
                          <i
                            className="fa fa-exclamation-circle"
                            aria-hidden="true"
                          ></i>
                          {this.state.errors.name}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Col>
            <Col md={5}>
              <div className={styles.rightDetails}>
                <div className={cx(styles.listMeta, styles.first)}>
                  <span className={styles.label}>{this.localizedCommons.updated_on}:</span>
                  <span className={styles.value}>
                    {dateformat(
                      this.props.contactList.modifiedDate,
                      "dd-mmm-yyyy"
                    )}
                  </span>
                </div>
                <div className={styles.listMeta}>
                  <span className={styles.label}>{this.localizedCommons.created_by}:</span>
                  <span
                    className={styles.value}
                  >{`${this.props.user.firstName} ${this.props.user.lastName}`}</span>
                </div>
              </div>
            </Col>
          </Row>
          {this._renderContacts()}
        </div>

        <Transition in={this.state.editing} timeout={0}>
          {(state) => {
            return (
              <div className={cx(styles.actions, styles[state])}>
                <Button 
                text={this.props.updating ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save}
                disabled={this.props.updating}
                variant='primary'
                onClick={this._handleSaveClick}
                />
                <Button
                text={this.localizedCommonActions.cancel}
                onClick={this._handleCancelClick}
                />
              </div>
             
            );
          }}
        </Transition>
        <Slider.Dialog width="28vw" show={this.state.showDeleteConfirmation}>
          <DeleteContactListContainer
            id={this.props.contactList.id}
            onDeletion={() => {
              this.setState({
                showDeleteConfirmation: false,
              });
            }}
            onCancel={() => {
              this.setState({
                showDeleteConfirmation: false,
              });
            }}
          />
        </Slider.Dialog>

      </div>
    );
  }

  _renderContacts() {
    const canAddContacts = _.size(this.props.contactList.contacts) < 100;
    var isEmpty=false

    if (
      !this.props.loading &&
      this.props.contactList &&
      this.props.contactList.contacts &&
      this.props.contactList.contacts.length == 0
    ) {

      isEmpty=true
    }

    if (this.props.loading) {
      return <div className={styles.loading}>{this.localizedCommonLoading.loading}...</div>;
    }

    var items = this.props.contactList.contacts || [];
    var contacts = items.map((contact) => {
      return (
        <ContactListItemRow
          key={contact.id}
          editing={this.state.editing}
          contact={contact}
          contactList={this.props.contactList ? this.props.contactList.id : ""}
          onRemove={this._handleRemoveContact}
        />
      );
    });

    return (
      
      <div className={styles.contactListItems}>
        <Row className={styles.contactsHeading}>
          <Col md={7} className={styles.column}>
            <span>{`${this.localizedCommons.contact} (${this.props.contactList.contacts
                ? this.props.contactList.contacts.length
                : 0
              })`}</span>
          </Col>
          <Col md={5} className={styles.column}>
          <ToolBar
            className={cx(styles.toolbar, { [styles.trial]: this.props.trial })}
          >
            <ToolBarGroup direction="right">
            <Actions.IconButton
                icon="paperflite-add"
                tooltip={this.localizedDistributionList.actions.add_contacts}
                disabled={!canAddContacts}
                onClick={this._handleAddContacts}
                className={styles.action}
              />
              <Actions.IconButton
                icon='paperflite-edit'
                tooltip={this.localizedDistributionList.actions.edit}
                onClick={this._handleUpdateClicked}
                className={styles.action}
              />
              <Actions.IconButton
                icon='paperflite-delete'
                tooltip={this.localizedDistributionList.actions.delete}
                onClick={this._handleDeleteClicked}
                className={styles.action}

              />
            </ToolBarGroup>
          </ToolBar>
          </Col>
          <div className={commonStyles.line}/>
        </Row>
        {isEmpty && this._renderEmptyMessage()}
        {!isEmpty && <div className={cx(styles.contactListItemContainer, { [styles.contactListSpacing]: !this.state.editing })}>{contacts}</div>}
      </div>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedDistributionList.empty_message.title}
        message={""}
        image={RolodexActivityEmptyMessage}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }
}

ContactListDetailsView.contextTypes = {
  store: PropTypes.object,
  router: PropTypes.object,
};

export default ContactListDetailsView;
